import styled from 'styled-components'

import type { Props } from '@/types/remoteworktown'

export default function TopicItem({ topic }: Readonly<Props>): JSX.Element {
  return (
    <Item className="c-item">
      <div className="c-item-info-row">
        <p className="c-item-info">{topic.publishDate.substring(0, 10)}</p>
        <p className="c-item-info">{topic.category.name}</p>
      </div>
      <a
        href={topic.file.src}
        target="_blank"
        rel="noreferrer noopener"
        className="c-item-title"
      >
        {topic.title}
      </a>
      {topic.isImportant && <p className="c-item-important">重要なお知らせ</p>}
    </Item>
  )
}

const Item = styled.li`
  width: 33.3%;
  padding: 0 90px 20px 20px;
  border-left: 4px solid #181e26;

  &:nth-child(n + 4) {
    margin-top: 60px;
  }

  .c-item-info-row {
    display: flex;
  }

  .c-item-info {
    font-size: 14px;
    color: #999;

    &:first-child::after {
      display: inline-block;
      content: '｜';
      margin: 0 8px;
      color: #999;
    }
  }

  .c-item-title {
    display: inline-block;
    margin-top: 12px;
    text-decoration: none;
    color: #30a8fb;
    font-size: 16px;
    line-height: 1.5;

    &:hover {
      text-decoration: underline;
    }
  }

  .c-item-important {
    display: block;
    color: #fff;
    background-color: #e20000;
    padding: 2px 10px;
    border-radius: 3px;
    font-size: 12px;
    margin-top: 12px;
    width: fit-content;
  }

  @media screen and (max-width: 1047px) {
    .c-item {
      width: 100%;
      padding: 0 0 20px 20px;

      &:nth-child(n + 2) {
        margin-top: 30px;
      }
    }

    .c-item-info {
      font-size: 1.3rem;
    }

    .c-item-title {
      font-size: 1.5rem;
    }
  }
`
